<template>
  <div class="pageWrapper">
    <div class="container align-items-center">
      <div class="left-text">
        <h1>Something went wrong...</h1>
        <p>The request could not be completed. Please try again or if the issue persists, please <router-link to="/contact">contact us</router-link>.</p>
      </div>
      <div class="right-image">
        <img class="img" src="/img/server-error-500.svg"/>
      </div>

    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {};
    },
    mounted () {
        this.$store.commit('loadingDashboardData', false);
        this.$store.commit('setLoader', { show: false, message: null });
        this.$store.commit('setDataLoaded', true);
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';

.container{
  height: 100%;
  display: flex;;
  @include responsive('sm') {
    display: block;;
  }
}
.left-text{
  width: 40%;
  h1{
    font-size: 30px;
    margin-bottom: 30px;
  }
  p{
    font-size: 20px;
  }
  @include responsive('sm') {
    width: 100%;
    padding-top: 30px;
    text-align: center;;
    padding-bottom: 30px;
  }
}
.right-image{
  width: 60%;
  @include responsive('sm') {
    width: 100%;
  }
}
.img{
    width: 100%;
  }
</style>
